/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.isInfinite = this.classList.contains('pagination-type--infinite');
      this.isLoadMore = this.classList.contains('pagination-type--loadmore');
    }
    connectedCallback() {
      if (this.isLoadMore) {
        this.loadMore();
      }
      if (this.isInfinite) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1],
        rootMargin: '0px 0px 500px 0px'
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        basePath = base.dataset.url || document.location.pathname,
        url = basePath + base.addUrlParam(document.location.search, 'page');      
      if (base.getAttribute('loading') && this.isLoadMore) {
        return;
      }
      base.i++;
      if(!base.getAttribute('loading')) {
        base.setAttribute('loading', true);
      }
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
      const hasProducts = grid_to_replace?.querySelector('.column');
      if (!grid_to_replace || !hasProducts) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        if (base.hasAttribute('loading')) {
          base.removeAttribute('loading');
        }
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }
      if (window.HulkappWishlist?.init) {
        window.HulkappWishlist.init();
      }
      const isInfinite = this.isInfinite;
      const isLoadMore = this.isLoadMore;
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            if(isLoadMore) { 
              base.removeAttribute('loading');
            }
          }
        });
      } else {
        if(this.isLoadMore) {
          base.removeAttribute('loading');
        }
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}